// Copyright (C) 2024 Yisi Yu
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.

import "./Button.css"
import {MouseEventHandler} from "react";

interface ButtonProps {
  text: string,
  onClick: MouseEventHandler<HTMLButtonElement>,
  variant?: 'default' | 'danger'
}

export default function Button({text, onClick, variant}: ButtonProps) {
  const buttonClass = variant === 'danger' ? 'button button-danger' : 'button';
  return <button className={buttonClass} onClick={onClick}>{text}</button>;
}
